//import React from "react";
import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

import { useGetApi, UsePostApi, UsePutApi, UseDeleteApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import ProfissionalForm from "./ProfissionalForm";

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";

import { noCaseSensitive } from 'beaktShared/helpers/extras';

const useStyles = makeStyles(styles);

export default function ProfissionalList() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const endPoint = 'profissionais/';

    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});
    const [loadingForm, setLoadingForm] = React.useState(false);

    const endPointGet = endPoint + "byestabelecimento/" + session.estabelecimentoId;
    const [{ list, isLoadingList, isErrorGetList }, setListAtualiza] = useGetApi(endPointGet);

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    const handleAdd = item => {

        var vefifyExists = list.filter(obj => {
            return obj.profissionalId === item.profissionalId;
        });

        var verifyInsert = false;
        if (item.profissionalId === 0)
            verifyInsert = true;

        if (!verifyInsert) {
            setLoadingForm(true);
            UsePutApi(endPoint, session.estabelecimentoId, item).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger');
                    setLoadingForm(false);
                    return false;
                }

                if (vefifyExists.length > 0) {
                    const updateList = list.map(l => (l.profissionalId === item.profissionalId ? item : l));
                    setListAtualiza(updateList);
                }
                else {
                    const addItemList = [...list, item];
                    setListAtualiza(addItemList);
                }

                loadafteradd(result.message);
                return true;
            });
        }
        else {
            setLoadingForm(true);
            UsePostApi(endPoint + session.estabelecimentoId, item).then(result => {
                if (result.status !== 201) {
                    showNotification(result.message, 'danger');
                    setLoadingForm(false);
                    return false;
                }

                if (vefifyExists.length > 0) {
                    const updateList = list.map(l => (l.profissionalId === item.profissionalId ? item : l));
                    setListAtualiza(updateList);
                }
                else {
                    const addItemList = [...list, result.data];
                    setListAtualiza(addItemList);
                }

                loadafteradd(result.message);
                return true;
            });
        }

        return false;
    };

    const handleDelete = profissionalId => {
        setLoadingForm(true);
        UseDeleteApi(endPoint, session.estabelecimentoId, profissionalId).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setLoadingForm(false);
                return false;
            }
            const updateList = list.filter(l => l.profissionalId !== profissionalId);
            setListAtualiza(updateList);
            loadafteradd(result.message);
            return true;
        });
    }

    const loadafteradd = (message) => {
        setLoadingForm(false);
        handleView(true);
        showNotification(message, 'success');
    }

    const handleView = (resetItem) => {
        if (resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);
    };

    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {

        const bodyDetail = (
            <div>
                {t('label.name')}: {row.nome}
                <br />
                Status: {row.ativo === true ? t('label.active') : t('label.inactive')}
                <br />
                {t('label.cell_phone')}: {row.celular}
                <br />
                {t('label.email')}: {row.email}
                <br />
            </div>);

        setConfModal({
            showmodal: true,
            dataShow: bodyDetail
        });
    };

    const handleEdit = row => {
        setItem(row);
        handleView(false);
    };

    useEffect(() => {
        if (session.tipoPerfil == 2 && list.length > 1) {
            setListAtualiza(list.filter(f => f.usuarioId == session.id));
        }
    }, [list]);

    const columnsProp = [{
        Header: t('label.name'),
        accessor: "nome"
    },
    {
        Header: t('label.cell_phone'),
        accessor: "celular"
    },
    {
        Header: t('label.email'),
        accessor: "email"
    }]
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    <Button
                        justIcon
                        round
                        simple
                        color="info"
                        className="info"
                        onClick={() => handleDetail(row.original)}
                    >
                        <Search />
                    </Button>{" "}
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={() => handleEdit(row.original)}
                    >
                        <Edit />
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp, ...columnsAcao]

    const classes = useStyles();
    
    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    };

    return (
        <div>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView &&
                <ProfissionalForm addItem={handleAdd} deleteItem={handleDelete} item={item} handleView={handleView} loading={loadingForm} />}

            {!showFormView &&
                <GridContainer>
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <Assignment />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>{t('register.list_of_professionals')}</h4>
                            </CardHeader>
                            <CardBody>
                                {session.tipoPerfil != 2 &&
                                    <Button
                                        color="primary"
                                        className={classes.newButton}
                                        onClick={() => handleView(true)}
                                    >
                                        {t('button.new')}
                                    </Button>
                                }

                                {isErrorGetList && <div>{t('error_message.list_of_professionals')}...</div>}
                                <ReactTable
                                    loading={isLoadingList}
                                    data={list}
                                    columns={columns}
                                    filterable
                                    defaultFilterMethod={noCaseSensitive}
                                    defaultPageSize={10}
                                    minRows={5}
                                    showPaginationBottom={true}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading') + "..."}
                                    noDataText={t('information_message.no_records_found') + "!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                    onPageChange={() => sendScrollToTOP()}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            }

            {detailModal}
        </div>
    );
}
